export function sortByCreated(data: any[]) {
  return data?.sort((a, b) => {
    const dataA = new Date(a.created_at).getTime();
    const dataB = new Date(b.created_at).getTime();

    return dataB - dataA;
  });
}
